module.exports = __webpack_public_path__ + "static/media/wheelbarrow.0c97c868.svg";